var map = {
	"./ion-action-sheet.entry.js": [
		2219,
		5
	],
	"./ion-alert.entry.js": [
		2220,
		6
	],
	"./ion-app_8.entry.js": [
		2221,
		7
	],
	"./ion-avatar_3.entry.js": [
		2222,
		17
	],
	"./ion-back-button.entry.js": [
		2223,
		18
	],
	"./ion-backdrop.entry.js": [
		2224,
		47
	],
	"./ion-button_2.entry.js": [
		2225,
		19
	],
	"./ion-card_5.entry.js": [
		2226,
		20
	],
	"./ion-checkbox.entry.js": [
		2227,
		21
	],
	"./ion-chip.entry.js": [
		2228,
		22
	],
	"./ion-col_3.entry.js": [
		2229,
		48
	],
	"./ion-datetime_3.entry.js": [
		2230,
		10
	],
	"./ion-fab_3.entry.js": [
		2231,
		23
	],
	"./ion-img.entry.js": [
		2232,
		49
	],
	"./ion-infinite-scroll_2.entry.js": [
		2233,
		50
	],
	"./ion-input.entry.js": [
		2234,
		24
	],
	"./ion-item-option_3.entry.js": [
		2235,
		25
	],
	"./ion-item_8.entry.js": [
		2236,
		26
	],
	"./ion-loading.entry.js": [
		2237,
		27
	],
	"./ion-menu_3.entry.js": [
		2238,
		28
	],
	"./ion-modal.entry.js": [
		2239,
		8
	],
	"./ion-nav_2.entry.js": [
		2240,
		14
	],
	"./ion-popover.entry.js": [
		2241,
		9
	],
	"./ion-progress-bar.entry.js": [
		2242,
		29
	],
	"./ion-radio_2.entry.js": [
		2243,
		30
	],
	"./ion-range.entry.js": [
		2244,
		31
	],
	"./ion-refresher_2.entry.js": [
		2245,
		11
	],
	"./ion-reorder_2.entry.js": [
		2246,
		16
	],
	"./ion-ripple-effect.entry.js": [
		2247,
		51
	],
	"./ion-route_4.entry.js": [
		2248,
		32
	],
	"./ion-searchbar.entry.js": [
		2249,
		33
	],
	"./ion-segment_2.entry.js": [
		2250,
		34
	],
	"./ion-select_3.entry.js": [
		2251,
		35
	],
	"./ion-slide_2.entry.js": [
		2252,
		52
	],
	"./ion-spinner.entry.js": [
		2253,
		13
	],
	"./ion-split-pane.entry.js": [
		2254,
		53
	],
	"./ion-tab-bar_2.entry.js": [
		2255,
		36
	],
	"./ion-tab_2.entry.js": [
		2256,
		15
	],
	"./ion-text.entry.js": [
		2257,
		37
	],
	"./ion-textarea.entry.js": [
		2258,
		38
	],
	"./ion-toast.entry.js": [
		2259,
		39
	],
	"./ion-toggle.entry.js": [
		2260,
		12
	],
	"./ion-virtual-scroll.entry.js": [
		2261,
		54
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 479;
module.exports = webpackAsyncContext;